const NewlineText = (text) => {
  const newText = text?.split("\r").map((str) => str);

  return newText;
};
export default NewlineText;
